export default __webpack_public_path__ + "content/media/21.6a03423e.jpg";